import { adminHttpClient } from '../../../commons/adminHttpClient'

const isOpenEnrollmentPeriod = (): Promise<boolean> => {
  return adminHttpClient.get(`/Benefit/BenefitRenewal/Qshera/IsOpenEnrollmentPeriod`)
}

export default isOpenEnrollmentPeriod
